var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 23H2.21C1.54 23 1 22.46 1 21.79V2.21C1 1.54 1.54 1 2.21 1h19.57c.68 0 1.22.54 1.22 1.21v19.57c0 .67-.54 1.21-1.21 1.21h-5.61v-8.52h2.86l.43-3.32h-3.29V9.04c0-.96.27-1.62 1.65-1.62h1.76V4.45c-.3-.04-1.35-.13-2.56-.13-2.53 0-4.27 1.55-4.27 4.39v2.45H9.88v3.32h2.87V23z"
  })));
}

export default SvgSocialFacebook;